export const experienceData = [
{
        id: 1,
        company: 'Nohemi Velazco - Creative Studio',
        jobtitle: 'Founder and Creative Designer',
        startYear: 'July 2026',
        endYear: ''
    },
    {
        id: 2,
        company: 'Spark Technologies',
        jobtitle: 'Software Developer',
        startYear: 'June 2025',
        endYear: 'July 2026'
    },
    {
        id: 3,
        company: 'TECNOLOchicas',
        jobtitle: 'Instructor',
        startYear: 'July 2024',
        endYear: ''
    },
    {
        id: 4,
        company: 'Fixer MX',
        jobtitle: 'Frontend Developer',
        startYear: 'July 2024',
        endYear: 'December 2024'
    },
]